'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX_CLS = exports.PREFIX_CLS = 'ant-fullcalendar';


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/calendar/Constants.js
// module id = 226
// module chunks = 0